/* CW hero: the audience becomes the engine.
   Test build. Patches the existing hero at runtime, no section edits.
   Config comes from window.CW_HERO, set inline in layout/theme.liquid. */
(function () {
  var D = { mode: 'arena', drive: 'scroll', n: 900, gearX: 0.68, gearY: 0.72 };
  var CFG = window.CW_HERO || {};
  for (var k in D) if (CFG[k] === undefined) CFG[k] = D[k];

  function boot() {
    var hero = document.querySelector('section.hero');
    if (!hero || document.getElementById('cwField')) return;

    var old = document.getElementById('threeCanvas');
    if (old) old.parentNode.removeChild(old);

    hero.classList.add('cw-dark');
    hero.setAttribute('data-bg', 'ink');

    var track = document.createElement('div');
    track.className = 'cw-track';
    hero.parentNode.insertBefore(track, hero);
    track.appendChild(hero);

    var cvs = document.createElement('canvas');
    cvs.id = 'cwField';
    hero.insertBefore(cvs, hero.firstChild);

    run(cvs, track, hero.querySelector('.scroll-cue'));
  }

  function run(cvs, track, cue) {
    var ctx = cvs.getContext('2d');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DPR = Math.min(devicePixelRatio || 1, 2);
    var N = innerWidth < 760 ? Math.round(CFG.n * 0.45) : CFG.n;
    var W = 0, H = 0, pts = [], targets = [];

    var MOD = 0.26;
    var CHAIN = [
      { r: 0.30,  a: null, rose: false },
      { r: 0.17,  a: 196,  rose: false },
      { r: 0.11,  a: 272,  rose: true  },
      { r: 0.23,  a: 8,    rose: false },
      { r: 0.075, a: 128,  rose: false }
    ];

    function buildTargets() {
      var S = Math.min(W, H), i, k;
      for (i = 0; i < CHAIN.length; i++) {
        var g = CHAIN[i]; g.R = g.r * S;
        if (i === 0) { g.x = W * CFG.gearX; g.y = H * CFG.gearY; continue; }
        var p = CHAIN[i - 1], d = p.R + g.R, rad = g.a * Math.PI / 180;
        g.x = p.x + Math.cos(rad) * d; g.y = p.y + Math.sin(rad) * d;
      }
      targets = [];
      var total = 0; for (i = 0; i < CHAIN.length; i++) total += CHAIN[i].R;
      for (i = 0; i < CHAIN.length; i++) {
        var gg = CHAIN[i], share = Math.round(N * (gg.R / total));
        var teeth = Math.max(9, Math.round(gg.R * MOD));
        for (k = 0; k < share; k++) {
          var u = k / share, rr, aa;
          if (u < 0.62) { rr = gg.R; aa = u / 0.62 * Math.PI * 2; }
          else if (u < 0.82) { var ti = Math.floor((u - 0.62) / 0.20 * teeth);
            aa = ti / teeth * Math.PI * 2; rr = gg.R * (1.045 + (k % 3) * 0.03); }
          else if (u < 0.94) { var si = Math.floor((u - 0.82) / 0.12 * 6);
            aa = si / 6 * Math.PI * 2; rr = gg.R * (0.20 + ((k * 37) % 100) / 100 * 0.62); }
          else { rr = gg.R * 0.16; aa = (u - 0.94) / 0.06 * Math.PI * 2; }
          targets.push({ gi: i, rr: rr, aa: aa, rose: gg.rose });
        }
      }
      while (targets.length && targets.length < N) targets.push(targets[targets.length % targets.length]);
      targets.length = N;
    }

    function seed() {
      pts.length = 0;
      var TIERS = 8;
      for (var i = 0; i < N; i++) {
        var nx, ny, d;
        if (CFG.mode === 'stadium') {
          var tf = Math.floor(Math.pow(Math.random(), 1.5) * TIERS) / TIERS;
          nx = -0.06 + Math.random() * 1.12;
          var off = Math.min(1, Math.abs(nx - 0.5) / 0.5);
          ny = 1 - 0.015 - Math.pow(off, 2.1) * 0.17 - tf * 0.205 + (Math.random() - 0.5) * 0.018;
          d = tf * 0.9 + Math.random() * 0.1;
        } else if (CFG.mode === 'arena') {
          d = Math.random(); nx = -0.1 + Math.random() * 1.2;
          ny = 0.34 + Math.pow(1 - d, 1.75) * (1.06 - 0.34);
        } else { d = Math.random(); nx = Math.random(); ny = Math.random(); }
        var near = 1 - d;
        pts.push({ nx: nx, ny: ny, d: d, near: near,
          x: nx * (W || 1200), y: ny * (H || 800),
          s: 0.45 + near * 1.9, sway: 4 + near * 13, bob: 0.7 + near * 2.4,
          ph: Math.random() * Math.PI * 2, tw: Math.random() * Math.PI * 2,
          tws: 0.006 + Math.random() * 0.016, warmth: 0.82 + Math.random() * 0.18,
          flash: 0, stagger: Math.min(0.34, Math.max(0, nx)) * 0.34 });
      }
    }

    function size() {
      W = cvs.clientWidth; H = cvs.clientHeight;
      if (!W || !H) return;
      cvs.width = W * DPR; cvs.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      buildTargets();
      if (!pts.length || Math.abs(W - (size._w || 0)) > 2 || Math.abs(H - (size._h || 0)) > 2) {
        size._w = W; size._h = H; seed();
      }
    }

    var order = 0, t = 0, spin = 0, boost = 0, lastY = scrollY, mx = -9e9, my = -9e9;
    function ease(p) { return p < 0.5 ? 4*p*p*p : 1 - Math.pow(-2*p + 2, 3) / 2; }

    addEventListener('pointermove', function (e) {
      var r = cvs.getBoundingClientRect(); mx = e.clientX - r.left; my = e.clientY - r.top;
    });
    addEventListener('pointerleave', function () { mx = my = -9e9; });
    addEventListener('scroll', function () {
      boost += Math.min(50, Math.abs(scrollY - lastY)) * 0.06; lastY = scrollY;
    }, { passive: true });
    addEventListener('resize', size);

    function progress() {
      var total = track.offsetHeight - innerHeight;
      if (total <= 0) return 0;
      return Math.min(1, Math.max(0, -track.getBoundingClientRect().top / total));
    }

    function frame() {
      t++; boost *= 0.95; spin += 0.0022 + boost * 0.01;

      if (CFG.drive === 'scroll') {
        var sp = progress();
        order = ease(Math.min(1, Math.max(0, (sp - 0.08) / 0.66)));
        if (cue) cue.style.opacity = sp > 0.04 ? 0 : '';
      } else {
        var c = (t % 1560) / 1560;
        order = c < 0.16 ? 0 : c < 0.40 ? ease((c - 0.16) / 0.24)
              : c < 0.72 ? 1 : c < 0.92 ? 1 - ease((c - 0.72) / 0.20) : 0;
      }
      if (reduce) order = 1;

      if (order < 0.72 && Math.random() < 0.20 * (1 - order)) {
        var f = pts[(Math.random() * N) | 0]; if (f) f.flash = 1;
      }

      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = 0; i < N; i++) {
        var p = pts[i], tg = targets[i]; if (!p || !tg) continue;
        var ax = p.nx * W, ay = p.ny * H;
        var cx = ax + Math.sin(t * 0.0075 + p.nx * 5.0 + p.d * 1.6) * p.sway;
        var cy = ay + Math.sin(t * 0.011 + p.ph) * p.bob;

        var g = CHAIN[tg.gi], dir = tg.gi % 2 ? -1 : 1;
        var a = tg.aa + spin * (CHAIN[0].R / g.R) * dir;
        var tx = g.x + Math.cos(a) * tg.rr, ty = g.y + Math.sin(a) * tg.rr;

        var o = (order - p.stagger) / (1 - 0.34);
        if (mx > -1e8) { var dm = Math.sqrt((p.x-mx)*(p.x-mx) + (p.y-my)*(p.y-my));
          if (dm < 260) o += (1 - dm / 260) * 0.85; }
        o = Math.max(0, Math.min(1, o));

        var arc = Math.sin(o * Math.PI) * H * 0.11;
        p.x += ((cx + (tx - cx) * o) - p.x) * 0.075;
        p.y += ((cy + (ty - cy) * o - arc) - p.y) * 0.075;

        p.tw += p.tws; p.flash *= 0.86;
        var twinkle = 0.62 + Math.sin(p.tw) * 0.38;
        var warm = 1 - o, depth = 0.38 + p.near * 0.62;
        var alpha = (0.22 + 0.46 * twinkle) * depth * (0.6 + o * 0.4);
        var rad = p.s * (1 + warm * 0.42);
        if (p.flash > 0.02) { alpha = Math.min(1, alpha + p.flash * 0.85); rad *= 1 + p.flash * 2.6; }

        ctx.beginPath();
        ctx.fillStyle = tg.rose ? 'rgba(204,136,153,' + alpha + ')'
          : warm > 0.5 ? 'rgba(' + ((252*p.warmth)|0) + ',' + ((238*p.warmth)|0) + ',' + ((224*p.warmth)|0) + ',' + alpha + ')'
          : 'rgba(250,247,242,' + (alpha * 0.82) + ')';
        ctx.arc(p.x, p.y, rad, 0, 6.2832);
        ctx.fill();
      }
      ctx.globalCompositeOperation = 'source-over';
      requestAnimationFrame(frame);
    }

    size();
    requestAnimationFrame(frame);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
